import { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";

export function RegisterButton() {
    const app = useContext(AppContext);

    return (
        <>
            {!app.userLoggedIn && <Link className="btn btn-outline-contrast widescreen-only" to="/Register">Register</Link>}
        </>

    );
}